
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useTokenExpiryDetection = () => {
  const [tokenExpired, setTokenExpired] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Check if token_expired is in URL parameters
    const params = new URLSearchParams(location.search);
    const isTokenExpired = params.get('token_expired') === 'true';
    
    // Set the state based on URL parameter
    setTokenExpired(isTokenExpired);
    
    // If not in URL, check session storage as fallback
    if (!isTokenExpired && sessionStorage.getItem('token_expired') === 'true') {
      setTokenExpired(true);
      // Clean up session storage
      sessionStorage.removeItem('token_expired');
    }
  }, [location.search]);

  return { tokenExpired };
};
